import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BadgeColor, BadgeSize } from '../badge/badge.types';

@Component({
  selector: 'wfm-card-notification',
  templateUrl: './card-notification.component.html',
  styleUrls: ['./card-notification.component.scss']
})
export class CardNotificationComponent {
  @Input() badgeLabel: string;

  @Input() badgeColor: BadgeColor;

  @Input() items;

  @Output() close = new EventEmitter();

  @Output() cancel = new EventEmitter();

  badgeSize = BadgeSize.small;

  doCallCancel() {
    this.cancel.emit();
  }
}
